import { makeStyles } from '@material-ui/core';
import React from 'react';

interface LinkProps {
    onClick: () => void;
    children: React.ReactNode;
}

const Link = React.forwardRef<HTMLButtonElement, LinkProps>(
    ({ onClick, children }, ref) => {
        const classes = useStyles();

        return (
            <button
                ref={ref}
                className={classes.link}
                onClick={onClick}
                type="button"
            >
                {children}
            </button>
        );
    }
);

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.gray.dark,
        fontFamily: 'Noto Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.252px',
        textDecorationLine: 'underline',
        textDecorationStyle: 'solid',
        textDecorationSkipInk: 'none',
        textDecorationThickness: 'auto',
        textUnderlineOffset: 'auto',
        textUnderlinePosition: 'from-font',
        cursor: 'pointer',
        border: 'none',
        background: 'none',
    },
}));

Link.displayName = 'Link';
export default Link;
